import React from 'react';
import { useReveal } from '../lib/useReveal';
import { SproutIcon, HeartHandshakeIcon, SparklesIcon, GlobeIcon } from 'lucide-react';
const CARDS = [{
  icon: SproutIcon,
  title: 'Aprendé desde cero'
}, {
  icon: HeartHandshakeIcon,
  title: 'Realizá sesiones Reiki'
}, {
  icon: SparklesIcon,
  title: 'Trabajá con Chakras'
}, {
  icon: GlobeIcon,
  title: 'Reiki Presencial y a Distancia'
}];
export function IntroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#F4F2EE] py-20 md:py-32 px-5 sm:px-6 border-t border-[#EAE6E1]" data-id="element-247">
      <div className="container mx-auto max-w-5xl" data-id="element-248">
        <div ref={ref1} className={`reveal text-center mb-16 md:mb-20 ${vis1 ? 'is-visible' : ''}`} data-id="element-249">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E2330] mb-6 leading-tight max-w-3xl mx-auto" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-250">
            ¿Te gustaría aprender Reiki de forma completa y profesional?
          </h2>
          <p className="text-[#4A5568] text-lg md:text-xl max-w-2xl mx-auto leading-relaxed" data-id="element-251">
            Esta formación fue diseñada para quienes desean comenzar desde cero
            y avanzar paso a paso hasta alcanzar la Maestría, con bases sólidas
            y prácticas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-252">
          {CARDS.map((card, idx) => {
          const Icon = card.icon;
          return <div key={idx} className="bg-white rounded-3xl p-8 shadow-[0_10px_40px_rgba(0,0,0,0.03)] border border-[#EAE6E1] flex flex-col items-center text-center transition-all duration-300 hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)] hover:-translate-y-1" data-id="element-253">
                <span className="w-16 h-16 rounded-2xl bg-[#FAFAF8] flex items-center justify-center mb-6 border border-[#EAE6E1]" data-id="element-254">
                  <Icon className="w-8 h-8 text-[#D4AF37]" strokeWidth={1.5} data-id="element-255" />
                </span>
                <h3 className="text-[#1E2330] text-lg font-bold leading-snug" data-id="element-256">
                  {card.title}
                </h3>
              </div>;
        })}
        </div>
      </div>
    </section>;
}